/*
 * Bundle assemble: five product tiles fly in from different edges and lock into the grid as you scroll, then the price
 * counts down from the real MRP to the real sale price (both read from the product). Transforms and opacity only.
 * Final state (assembled grid, sale price) for reduced motion and without scripts.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ex-bundle]');
  if (!root || !window.EluxaScroll || window.EluxaScroll.reduced()) return;

  var stage = root.querySelector('.ex-bd__stage');
  var tiles = [].slice.call(root.querySelectorAll('.ex-bd__tile'));
  var nowEl = root.querySelector('[data-now]');
  var mrpEl = root.querySelector('.ex-bd__mrp');
  var offEl = root.querySelector('.ex-bd__off');
  var cta = root.querySelector('.ex-bd__cta');
  if (!tiles.length) return;

  var mrp = parseFloat(root.getAttribute('data-mrp')) || 0;
  var price = parseFloat(root.getAttribute('data-price')) || 0;
  var counts = mrp > price && price > 0 && nowEl;
  root.classList.add('is-anim');

  // each tile arrives from a different edge, turning as it comes in
  var DIRS = [[-1, 0, -12], [0, -1, 10], [1, 0, 14], [0, 1, -10], [1, -0.7, 8], [-1, 0.7, -8]];
  var W = 800, H = 800;
  var fmt = window.Intl && Intl.NumberFormat ? new Intl.NumberFormat('en-IN') : null;

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function money(v) { return '₹' + (fmt ? fmt.format(v) : String(v)); }
  function measure() { W = stage.clientWidth; H = stage.clientHeight; }

  function render(p) {
    for (var i = 0; i < tiles.length; i++) {
      var d = DIRS[i % DIRS.length];
      var local = clamp((p - 0.03 - i * 0.1) / 0.3);
      var eo = easeOut(local);
      var bump = 0.035 * Math.sin(Math.PI * clamp((local - 0.82) / 0.18));
      var gap = 1 - eo;
      tiles[i].style.opacity = clamp(local * 2.5).toFixed(3);
      tiles[i].style.transform = 'translate3d(' + (d[0] * gap * W * 0.95).toFixed(1) + 'px,' + (d[1] * gap * H * 0.95).toFixed(1) + 'px,0) rotate(' + (d[2] * gap).toFixed(2) + 'deg) scale(' + (0.6 + 0.4 * eo + bump).toFixed(3) + ')';
      tiles[i].style.setProperty('--lk', clamp((local - 0.88) / 0.12).toFixed(3));
    }
    if (counts) {
      var q = ease(clamp((p - 0.5) / 0.38));
      nowEl.textContent = money(Math.round(mrp + (price - mrp) * q));
      if (mrpEl) mrpEl.style.opacity = clamp((q - 0.15) * 4).toFixed(3);
      if (offEl) offEl.style.opacity = clamp((q - 0.9) * 10).toFixed(3);
    } else {
      if (mrpEl) mrpEl.style.opacity = '1';
      if (offEl) offEl.style.opacity = '1';
    }
    if (cta) {
      var l = easeOut(clamp((p - 0.82) / 0.16));
      cta.style.opacity = l.toFixed(3);
      cta.style.transform = 'translate3d(0,' + ((1 - l) * 24).toFixed(1) + 'px,0)';
    }
  }

  // Tiles start off screen, so lazy loading would fetch them late: keep them lazy, but load them all as the section
  // comes within one screen of the viewport.
  var imgs = [].slice.call(root.querySelectorAll('.ex-bd__tile img'));
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      near.disconnect();
      imgs.forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); });
    }, { rootMargin: '100% 0px' });
    near.observe(root);
  } else {
    imgs.forEach(function (im) { im.loading = 'eager'; });
  }

  measure();
  window.addEventListener('resize', measure);
  window.EluxaScroll.pin(root, render);
})();
